// テキスト正規化ユーティリティ
// 書籍検索のあいまい一致（表記ゆれ・カタカナ/ひらがな・半角/全角）に使う。

// カタカナ → ひらがな
function katakanaToHiragana(s) {
  return s.replace(/[ァ-ヶ]/g, (ch) =>
    String.fromCharCode(ch.charCodeAt(0) - 0x60)
  );
}

// 検索用に文字列を正規化する。
// - NFKC: 全角英数 → 半角、半角カタカナ → 全角カタカナ、合成済み濁点を分解／結合
// - カタカナ → ひらがな
// - 小文字化
// - 連続空白を 1 つに（空白で区切られた語の順不同マッチに使いやすくする）
// - 前後の空白除去
export function normalizeForSearch(s) {
  if (s === null || s === undefined) return '';
  let t = String(s).normalize('NFKC');
  t = katakanaToHiragana(t);
  t = t.toLowerCase();
  t = t.replace(/\s+/g, ' ').trim();
  return t;
}

// 検索キーワードを空白区切りで分割し、全ての語が含まれる場合に一致とする（AND 検索）。
// 例: 「ハイデガー 存在」→ "ハイデガー" と "存在" の両方を含む書籍がヒット。
export function fuzzyMatch(haystack, query) {
  if (!query) return true;
  const hay = normalizeForSearch(haystack);
  const terms = normalizeForSearch(query)
    .split(' ')
    .filter(Boolean);
  if (terms.length === 0) return true;
  return terms.every((t) => hay.includes(t));
}
